import { useState } from 'react';
import { Box, Image, Text, VStack, Heading, useBreakpointValue } from '@chakra-ui/react';
import { motion } from 'framer-motion';
import { BookGalleryItem } from '../../constants/reading26';

const MotionBox = motion(Box);

interface BookCardProps {
    book: BookGalleryItem;
}

export default function BookCard({ book }: BookCardProps) {
    const [isRevealed, setIsRevealed] = useState(false);
    const isMobile = useBreakpointValue({ base: true, md: false });

    const handleTap = () => {
        if (isMobile) {
            setIsRevealed(!isRevealed);
        }
    };

    const handleHoverStart = () => {
        if (!isMobile) {
            setIsRevealed(true);
        }
    };

    const handleHoverEnd = () => {
        if (!isMobile) {
            setIsRevealed(false);
        }
    };

    return (
        <MotionBox
            position="relative"
            borderRadius="lg"
            overflow="hidden"
            boxShadow="lg"
            initial="rest"
            animate={isRevealed ? "hover" : "rest"}
            layoutId={`card-${book.title}`}
            onTap={handleTap}
            onHoverStart={handleHoverStart}
            onHoverEnd={handleHoverEnd}
        >
            <Image src={book.coverUrl} alt={`${book.title} cover`} w="100%" h="auto" objectFit="cover" />

            <MotionBox
                position="absolute"
                bottom="0"
                left="0"
                right="0"
                bg="rgba(0, 0, 0, 0.7)"
                p={4}
                variants={{
                    rest: { y: '100%' },
                    hover: { y: 0 }
                }}
                transition={{ type: 'tween', duration: 0.3 }}
            >
                <VStack spacing={1} align="start" color="white">
                    <Heading size="sm" noOfLines={2}>{book.title}</Heading>
                    <Text fontSize="xs">{book.author}</Text>
                </VStack>
            </MotionBox>
        </MotionBox>
    );
}
